(() => {
  // Handle the header's mobile nav drawer.
  const toggle = document.getElementById('header-nav-toggle');
  const dialog = document.getElementById('header-nav-dialog');
  if (!toggle || !dialog) return;

  toggle.addEventListener('click', () => {
    window.openDialog(dialog.id, toggle.id);
  });

  const closeButton = dialog.querySelector('[data-dialog-close]');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      window.closeDialog(closeButton);
    });
  }

  // Close the drawer when clicking its backdrop.
  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('dialog-backdrop')) {
      window.aria.closeCurrentDialog();
    }
  });
})();

(() => {
  // Quick exit: whisk the user away to another site as fast as
  // possible. It also wipes this page from the tab's history.
  //
  // The button is a real `target="_blank"` link to BBC News, so the
  // browser opens that tab itself as a direct result of the tap —
  // this is never blocked by a popup blocker, unlike a script-invoked
  // window.open() or a synthetic click. We don't call preventDefault(),
  // so that native navigation still happens.
  //
  // Safari (incl. iOS) cancels that native new-tab navigation if we
  // also replace the current page's location synchronously within the
  // same click handler — it treats the two as competing and drops the
  // popup silently. Deferring the replace by a macrotask (a plain
  // microtask isn't enough) lets the browser finish opening the new
  // tab first. The delay is imperceptible but reliably avoids the race
  // — verified in Chromium, Firefox and WebKit (incl. mobile viewport).
  const button = document.querySelector('[data-quick-exit]');
  if (!button) return;

  button.addEventListener('click', () => {
    setTimeout(() => {
      window.location.replace('https://www.bbc.co.uk/weather');
    }, 100);
  });
})();

(() => {
  // Handle overflowing reel components.
  const className = 'reel';
  const reels = Array.from(document.querySelectorAll(`.${className}`));
  const toggleOverflowClass = elem => {
    elem.classList.toggle('overflowing', elem.scrollWidth > elem.clientWidth);
  };

  for (let reel of reels) {
    if ('ResizeObserver' in window) {
      new ResizeObserver(entries => {
        toggleOverflowClass(entries[0].target);
      }).observe(reel);
    }

    if ('MutationObserver' in window) {
      new MutationObserver(entries => {
        toggleOverflowClass(entries[0].target);
      }).observe(reel, {childList: true});
    }
  }
})();

(() => {
  // Build a table of contents from the H2s inside the page's content, then
  // track which section is in view and flag its link as the current one.
  const headings = document.querySelectorAll('[data-toc-source] h2');
  const nav = document.querySelector('.u-toc');
  if (!nav) return;

  const list = nav.querySelector('ol');
  const used = new Set();

  headings.forEach(h => {
    const base = h.textContent.trim().toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    let id = base, i = 1;
    while (used.has(id) || document.getElementById(id)) id = `${base}-${i++}`;
    used.add(id);

    h.id = id;
    h.tabIndex = -1;

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
  });

  nav.hidden = false;

  // Scrollspy: whichever heading last crossed the very top of the viewport
  // is treated as the section the reader is currently in.
  let activeLink = null;
  const setActive = (link) => {
    if (!link || link === activeLink) return;
    if (activeLink) activeLink.removeAttribute('aria-current');
    link.setAttribute('aria-current', 'location');
    activeLink = link;
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setActive(list.querySelector(`a[href="#${entry.target.id}"]`));
      }
    });
  }, { rootMargin: '0px 0px -90% 0px' });

  headings.forEach(h => observer.observe(h));
})();
